import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=72b096ca&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=72b096ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/dhulsman/Projects/rentmagic.website.vue.defietsambassadegent/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BAlert, BCol, BRow, BCard, BButton, BTable, BForm, BContainer} from 'bootstrap-vue'
    installComponents(component, {BAlert, BCol, BRow, BCard, BButton, BTable, BForm, BContainer})
    

export default component.exports